function executeEventAdapter(data) {
  const { eventName, eventData } = data;
  return { action: eventName, payload: eventData.payload };
}

export default executeEventAdapter;
